import CryptoJS from 'crypto-js';

// 🔑 核心配置（前后端必须完全一致！）
// 建议生产环境从环境变量读取，示例用 16位密钥/偏移量
const AES_CONFIG = {
  key: CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_KEY), // 16位密钥
  iv: CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_IV),    // 16位偏移量
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7
};

/**
 * AES加密：统一处理对象/字符串
 * @param {object|string} data 明文数据
 * @returns {string} 加密后的Base64字符串
 */
export function aesEncrypt(data) {
  try {
    // 1. 统一转为JSON字符串（处理对象类型）
    const plainText = typeof data === 'object' 
      ? JSON.stringify(data) 
      : String(data || '');
    
    // 2. UTF8编码后加密
    const src = CryptoJS.enc.Utf8.parse(plainText);
    const encrypted = CryptoJS.AES.encrypt(src, AES_CONFIG.key, {
      iv: AES_CONFIG.iv,
      mode: AES_CONFIG.mode,
      padding: AES_CONFIG.padding
    });
    
    // 3. 返回Base64格式加密结果
    return encrypted.toString();
  } catch (err) {
    console.error('AES加密失败：', err);
    throw new Error('数据加密失败，请检查配置');
  }
}

/**
 * AES解密（前端可选，如需解密后端返回数据则保留）
 * @param {string} encryptedStr 加密后的Base64字符串
 * @returns {object|string} 解密后的明文
 */
export function aesDecrypt(encryptedStr) {
  try {
    const decrypt = CryptoJS.AES.decrypt(encryptedStr, AES_CONFIG.key, {
      iv: AES_CONFIG.iv,
      mode: AES_CONFIG.mode,
      padding: AES_CONFIG.padding
    });
    const plainText = decrypt.toString(CryptoJS.enc.Utf8);
    // 尝试解析为JSON对象（兼容对象/字符串）
    try {
      return JSON.parse(plainText);
    } catch (e) {
      return plainText;
    }
  } catch (err) {
    console.error('AES解密失败：', err);
    throw new Error('数据解密失败，请检查配置');
  }
}